export default {
  ISO_TOITURE: {
    name: 'ISO_TOITURE',
    label: 'Isolation Toiture',
    image: 'iso-toiture',
    group: 'reno-bati'
  },
  ISO_TOITURE_TERRASSE: {
    name: 'ISO_TOITURE_TERRASSE',
    label: 'Isolation Toiture terrasse',
    image: 'iso-toiture-terrasse',
    group: 'reno-bati'
  },
  ISO_COMBLES_PERDUS: {
    name: 'ISO_COMBLES_PERDUS',
    label: 'Isolation combles perdus',
    image: 'iso-combles-perdus',
    group: 'reno-bati'
  },
  ISO_COMBLES_AMENAGEABLES: {
    name: 'ISO_COMBLES_AMENAGEABLES',
    label: 'Isolation combles aménageables',
    image: 'iso-combles-amenageables',
    group: 'reno-bati'
  },
  ISO_MURS: {
    name: 'ISO_MURS',
    label: 'Isolation mur',
    image: 'iso-murs',
    group: 'reno-bati'
  },
  ISO_MURS_EXT: {
    name: 'ISO_MURS_EXT',
    label: 'Isolation des murs extérieurs',
    image: 'iso-murs',
    group: 'reno-bati'
  },
  ISO_MURS_INT: {
    name: 'ISO_MURS_INT',
    label: 'Isolation des murs intérieurs',
    image: 'iso-murs',
    group: 'reno-bati'
  },
  ISO_PLANCHERS: {
    name: 'ISO_PLANCHERS',
    label: 'Isolation planchers',
    image: 'iso-plancher',
    group: 'reno-bati'
  },
  FENETRES: {
    name: 'FENETRES',
    label: 'Fenêtres',
    image: 'fenetres',
    group: 'reno-bati'
  },
  CHAUDIERE_BIOMASSE: {
    name: 'CHAUDIERE_BIOMASSE',
    label: 'Chaudière biomasse',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  CHAUDIERE_FIOUL_CONDENS: {
    name: 'CHAUDIERE_FIOUL_CONDENS',
    label: 'Chaudière fioul condensation',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  CHAUDIERE_FIOUL_BASSE_TEMP: {
    name: 'CHAUDIERE_FIOUL_BASSE_TEMP',
    label: 'Chaudière fioul installée basse température',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  CHAUDIERE_GAZ_BASSE_TEMP: {
    name: 'CHAUDIERE_GAZ_BASSE_TEMP',
    label: 'Chaudière gaz installée basse température',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  CHAUDIERE_GAZ_CONDENS: {
    name: 'CHAUDIERE_GAZ_CONDENS',
    label: 'Chaudière individuelle gaz condensation',
    image: 'chaudiere-individuelle',
    group: 'reno-chauffage'
  },
  CHAUDIERE_GRANULES: {
    name: 'CHAUDIERE_GRANULES',
    label: 'Chaudières granûlés',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  CHAUDIERE_BUCHES: {
    name: 'CHAUDIERE_BUCHES',
    label: 'Chaudières bûches',
    image: 'chaudiere',
    group: 'reno-chauffage'
  },
  PAC_AIR_AIR: {
    name: 'PAC_AIR_AIR',
    label: 'Pompe à chaleur air-air',
    image: 'pac',
    group: 'pac'
  },
  PAC_AIR_EAU: {
    name: 'PAC_AIR_EAU',
    label: 'Pompe à chaleur air-eau',
    image: 'pac',
    group: 'pac'
  },
  PAC_EAU_EAU: {
    name: 'PAC_EAU_EAU',
    label: 'Pompe à chaleur eau-eau',
    image: 'pac',
    group: 'pac'
  },
  PAC_GEOTHERMIQUE: {
    name: 'PAC_GEOTHERMIQUE',
    label: 'Pompe à chaleur géothérmique',
    image: 'pac',
    group: 'pac'
  },
  SYSTEME_SOLAIRE_COMBINE: {
    name: 'SYSTEME_SOLAIRE_COMBINE',
    label: 'Système solaire combiné',
    image: 'equipement-solaire',
    group: 'equipement-solaire'
  },
  POELE_GRANULES: {
    name: 'POELE_GRANULES',
    label: 'Poêle à granulés',
    image: 'poele',
    group: 'reno-chauffage'
  },
  POELE_BUCHES: {
    name: 'POELE_BUCHES',
    label: 'Poêle à bûches',
    image: 'poele',
    group: 'reno-chauffage'
  },
  FOYER_INSERT: {
    name: 'FOYER_INSERT',
    label: 'Foyer fermé / insert',
    image: 'poele',
    group: 'reno-chauffage'
  },
  INSTALL_EMETTEURS_BASSE_TEMP: {
    name: 'INSTALL_EMETTEURS_BASSE_TEMP',
    label: 'Installation d\'émetteurs basse température',
    image: 'radiateur-emetteur',
    group: 'reno-chauffage'
  },
  INSTALL_ECHANGERUR_PAC_EAU_EAU: {
    name: 'INSTALL_ECHANGERUR_PAC_EAU_EAU',
    label: 'Installation d\'un échangeur pour PAC Eau-Eau',
    image: 'pac',
    group: 'pac'
  },
  INSTALL_ECHANGERUR_PAC_GEO: {
    name: 'INSTALL_ECHANGERUR_PAC_GEO',
    label: 'Installation d\'un échangeur pour PAC géothermique',
    image: 'pac',
    group: 'pac'
  },
  CET: {
    name: 'CET',
    label: 'Chauffe-eau thermodynamique',
    image: 'equipement-solaire',
    group: 'equipement-solaire'
  },
  CESI: {
    name: 'CESI',
    label: 'Chauffe-eau solaire individuel',
    image: 'equipement-solaire',
    group: 'equipement-solaire'
  },
  PUITS_CLIMATIQUE: {
    name: 'PUITS_CLIMATIQUE',
    label: 'Puits climatique',
    image: 'puit-climatique',
    group: 'equipement-solaire'
  },
  RADIATEUR_GAZ_VENTOUSE: {
    name: 'RADIATEUR_GAZ_VENTOUSE',
    label: 'Radiateurs gaz à ventouse',
    image: 'radiateur-emetteur',
    group: 'equipement-solaire'
  },
  VENTIL_DOUBLE_FLUX: {
    name: 'VENTIL_DOUBLE_FLUX',
    label: 'Ventilation mécanique double flux',
    image: 'ventilation',
    group: 'ventilation'
  },
  VENTIL_SIMPLE_FLUX_HYGRO: {
    name: 'VENTIL_SIMPLE_FLUX_HYGRO',
    label: 'Ventilation mécanique Hygroréglable',
    image: 'ventilation',
    group: 'ventilation'
  }
}
